import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";

const styles = makeStyles({
  auth: {
    position: "fixed",
    top: "0px",
    left: "0px",
    width: "100%",
    height: "100%",
    overflow: "auto",
  },
  authMain: {
    position: "relative",
    minWidth: "100%",
    minHeight: "100%",
    boxSizing: "border-box",
    padding: "50px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#432554",
  },
  authContent: {},
});

function Auth(props) {
  const classes = styles();
  return (
    <main className={classes.auth}>
      <div className={classes.authMain}>
        <section className={classes.authContent}>{props.children}</section>
      </div>
    </main>
  );
}

Auth.propTypes = {
  children: PropTypes.node.isRequired,
};

Auth.defaultProps = {
  children: null,
};

export default Auth;
